/**
 * The type of popup notification
 */
export enum PopUpNotificationType {
    /** text only */
    TextBased = 0,
    /** directs user to an action/component */
    ActionBased = 1,
    /** tutorial for new functionality  */
    Guided = 2
}